import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { ColorPickerModule } from 'primeng/colorpicker';
import { IncidentsTypesRoutingModule } from './incidents-types-routing.module';
import { IncidentsTypesListComponent } from './incidents-types-list/incidents-types-list.component';
import { IncidentsTypesDetailComponent } from './incidents-types-detail/incidents-types-detail.component';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        IncidentsTypesListComponent,
        IncidentsTypesDetailComponent
    ], imports: [CoreModule,
        IncidentsTypesRoutingModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        EditorModule,
        ColorPickerModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class IncidentsTypesModule { }
